import * as React from "react";
import {FreeTextField} from "../../../../../../Components/Form/FreeTextField";
import {FieldWrapper} from "./FieldWrapper";

interface IFlightNumberFieldProps {
    value: string;
    onChange(value: string): void;
    onDelete(): void;
}

export const FlightNumberField = ({value, onChange, onDelete}: IFlightNumberFieldProps) => (
    <FieldWrapper onDelete={onDelete}>
        <FreeTextField label="Flight Number" value={value} onChange={onChange}/>
    </FieldWrapper>
);
